export const DEFAULT_PRINT_RESOLUTION_DPMM = 8;
